/**
 * @generated SignedSource<<469edc69ef89361d433e76f99446ac6a>>
 * @relayHash 8119c0d691ff8bdb5cf6fa5298fcbc6b
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 8119c0d691ff8bdb5cf6fa5298fcbc6b

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commercialManagerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "email"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "firstname"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lastname"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "managementCenter"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "password"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "providerEmail"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "region"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "role"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sales"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userCode"
},
v11 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "commercialManagerId",
        "variableName": "commercialManagerId"
      },
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      },
      {
        "kind": "Variable",
        "name": "firstname",
        "variableName": "firstname"
      },
      {
        "kind": "Variable",
        "name": "lastname",
        "variableName": "lastname"
      },
      {
        "kind": "Variable",
        "name": "managementCenter",
        "variableName": "managementCenter"
      },
      {
        "kind": "Variable",
        "name": "password",
        "variableName": "password"
      },
      {
        "kind": "Variable",
        "name": "providerEmail",
        "variableName": "providerEmail"
      },
      {
        "kind": "Variable",
        "name": "region",
        "variableName": "region"
      },
      {
        "kind": "Variable",
        "name": "role",
        "variableName": "role"
      },
      {
        "kind": "Variable",
        "name": "sales",
        "variableName": "sales"
      },
      {
        "kind": "Variable",
        "name": "userCode",
        "variableName": "userCode"
      }
    ],
    "concreteType": "BasicResponse",
    "kind": "LinkedField",
    "name": "signUp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SignUpMutation",
    "selections": (v11/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v5/*: any*/),
      (v8/*: any*/),
      (v10/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v9/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "SignUpMutation",
    "selections": (v11/*: any*/)
  },
  "params": {
    "id": "8119c0d691ff8bdb5cf6fa5298fcbc6b",
    "metadata": {},
    "name": "SignUpMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "a0ca1c4e6a4dd0da89d76075ac939f45";

export default node;
